import { mapEnumToOptions } from '@abp/ng.core';

export enum LedgerType {
  Revenue = 0,
  Expense = 1,
  OwnBoatRevenue = 2,
  BoatExpense = 3,
}

export const ledgerTypeOptions = mapEnumToOptions(LedgerType);
